import { useAuthStore } from '~/stores/useAuthStore';
import { useSessionExpiredStore } from '~/stores/useSessionExpiredStore';
import { isLoginPath } from '~/composables/useSessionAuth';

const SESSION_BROADCAST_CHANNEL = 'sgate-session';

let broadcastChannel: BroadcastChannel | null = null;
let started = false;

const showSessionExpiredDialog = () => {
  if (isLoginPath()) return;

  const sessionExpiredStore = useSessionExpiredStore();
  if (!sessionExpiredStore.isVisible) {
    sessionExpiredStore.show();
  }
};

/** 다른 탭/창에 로그아웃 알림 (logout 직전 호출) */
export const notifySessionLogoutToOtherTabs = () => {
  if (!import.meta.client) return;

  try {
    const channel = new BroadcastChannel(SESSION_BROADCAST_CHANNEL);
    channel.postMessage({ type: 'LOGOUT' });
    channel.close();
  } catch {
    // BroadcastChannel 미지원 환경 무시
  }
};

const syncAuthStateAfterSessionExpired = () => {
  const auth = useAuthStore();
  auth.user = null;
  auth.isLoggedIn = false;
  auth.authorities = [];
  auth.lastCheckAuthReason = 'session';
};

const handleRemoteLogout = () => {
  const auth = useAuthStore();
  const sessionExpiredStore = useSessionExpiredStore();

  if (isLoginPath() || !auth.isLoggedIn || sessionExpiredStore.isVisible) return;

  showSessionExpiredDialog();
  syncAuthStateAfterSessionExpired();
};

/** 다른 탭 로그아웃 수신용 BroadcastChannel만 연결 */
export const startSessionMonitor = () => {
  if (!import.meta.client || started) return;
  started = true;

  try {
    broadcastChannel = new BroadcastChannel(SESSION_BROADCAST_CHANNEL);
    broadcastChannel.onmessage = (event: MessageEvent) => {
      if (event.data?.type === 'LOGOUT') {
        handleRemoteLogout();
      }
    };
  } catch {
    // ignore
  }
};

export const stopSessionMonitor = () => {
  if (!import.meta.client || !started) return;
  started = false;

  if (broadcastChannel) {
    broadcastChannel.close();
    broadcastChannel = null;
  }
};
